module.exports = __webpack_public_path__ + "static/flags/TK-fe0fc7b171d10bd8380b4fe675096d24.gif";